// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__3kEcO","header":"PatientBlock_header__2XPJa","label":"PatientBlock_label__GFr7l","option":"PatientBlock_option__3QTz7"};